
import React from "react";
import { Modal } from '@fluentui/react';
import SiteEditor from "./SiteEditor";

class EditModal extends React.Component {
    render() {
        const editor = <SiteEditor
            onRequestClose={this.props.onCloseModal}
            siteId={this.props.editedSite.id}
            callBack = {this.props.callBack}
        />
        const modal =   <Modal
                            isOpen={this.props.isModalOpened}
                            onDismiss={this.props.onCloseModal}
                            isModeless={false}
                            styles={modalStyles}
                            dragOptions={false}
                        >
                            <div>
                                {editor}
                            </div>
                        </Modal>

        return (
            <div style={{ background: 'none' }}>

                <div style={{ background: 'none' }}>
                    {modal}
                </div>

            </div>
        );
    }
}
export default EditModal

const modalStyles = {
    main: {
        maxHeight: '98%'
    },
    scrollableContent: {
        maxHeight: '100%'
    }
}



// WEBPACK FOOTER //
// ./src/components/EditSite/EditModal.js